stimulusApp.register(
  "booking-cancellation-final-confirmation",
  class extends Stimulus.Controller {
    confirm(event) {
      event.preventDefault()
      const form = document.querySelector(".cancellation-form")
      if (!form) {
        return
      }

      form.dataset.finalConfirmationAccepted = "true"
      const submitButton = form.querySelector("[type=submit]")
      form.requestSubmit(submitButton)
    }

    closeDrawer(event) {
      event.preventDefault()
      const drawerOverlay = document.querySelector(".drawer--overlay")
      drawerOverlay?.click()
    }
  },
)
